@if (isMobile() && !isExpanded()) {
  <button class="mobile-menu-button" type="button" (click)="toggleNav()" attr.aria-label="{{ 'nav.abrirMenu' | translate }}">
    <svg width="18" height="12" viewBox="0 0 19 13" fill="none">
      <path d="M0.5 12.5L18.5 12.5V10.5L0.5 10.5L0.5 12.5ZM0.5 7.5L18.5 7.5V5.5L0.5 5.5L0.5 7.5ZM0.5 0.5L0.5 2.5L18.5 2.5V0.5L0.5 0.5Z" fill="white"/>
    </svg>
  </button>
}

@if (isMobile() && isExpanded()) {
  <div class="mobile-overlay" (click)="toggleNav()"></div>
}

<div class="app-layout" [class.is-mobile]="isMobile()" [class.nav-expanded]="isExpanded()">

  <!-- ===== SIDEBAR ===== -->
  <aside class="nav-sidebar" [class.expanded]="isExpanded()" attr.aria-label="{{ 'nav.abrirMenu' | translate }}">

    <!-- FAB Section -->
    <div class="menu-fab-section">
      <button
        class="fab-btn"
        type="button"
        (click)="toggleNav()"
        [attr.aria-expanded]="isExpanded()"
        [attr.aria-label]="isExpanded() ? ('nav.cerrarMenu' | translate) : ('nav.abrirMenu' | translate)"
        [attr.title]="isExpanded() ? '' : ('nav.abrirMenu' | translate)"
      >
        @if (!isExpanded()) {
          <!-- Hamburger icon -->
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M3 18V16L21 16V18H3ZM3 13L3 11L21 11V13L3 13ZM3 8L3 6L21 6V8L3 8Z" fill="white"/>
          </svg>
        } @else {
          <!-- Close icon -->
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M19.5 6.91L18.09 5.5L12.5 11.09L6.91 5.5L5.5 6.91L11.09 12.5L5.5 18.09L6.91 19.5L12.5 13.91L18.09 19.5L19.5 18.09L13.91 12.5L19.5 6.91Z" fill="white"/>
          </svg>
        }
      </button>

      <!-- Logo — solo visible cuando el menú está expandido -->
      @if (isExpanded()) {
        <img
          class="nav-logo"
          src="assets/images/Logo.png"
          alt="RiskyID Logo"
        />
      }
    </div>

    <div class="nav-drawer-body">

      <!-- Items de navegación -->
      <nav class="nav-items" aria-label="Secciones principales">

        <!-- Cuenta -->
        <a
          class="nav-item"
          routerLink="/cuentas"
          routerLinkActive="active"
          [attr.title]="isExpanded() ? '' : ('nav.cuentas' | translate)"
          attr.aria-label="{{ 'nav.cuentas' | translate }}"
          (click)="closeNavOnMobile()"
        >
          <span class="nav-item-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <g clip-path="url(#clip0_2954_454)">
                <path d="M4 13C5.1 13 6 12.1 6 11C6 9.9 5.1 9 4 9C2.9 9 2 9.9 2 11C2 12.1 2.9 13 4 13ZM5.13 14.1C4.76 14.04 4.39 14 4 14C3.01 14 2.07 14.21 1.22 14.58C0.48 14.9 0 15.62 0 16.43V18H4.5V16.39C4.5 15.56 4.73 14.78 5.13 14.1ZM20 13C21.1 13 22 12.1 22 11C22 9.9 21.1 9 20 9C18.9 9 18 9.9 18 11C18 12.1 18.9 13 20 13ZM24 16.43C24 15.62 23.52 14.9 22.78 14.58C21.93 14.21 20.99 14 20 14C19.61 14 19.24 14.04 18.87 14.1C19.27 14.78 19.5 15.56 19.5 16.39V18H24V16.43ZM16.24 13.65C15.07 13.13 13.63 12.75 12 12.75C10.37 12.75 8.93 13.14 7.76 13.65C6.68 14.13 6 15.21 6 16.39V18H18V16.39C18 15.21 17.32 14.13 16.24 13.65ZM8.07 16C8.16 15.77 8.2 15.61 8.98 15.31C9.95 14.93 10.97 14.75 12 14.75C13.03 14.75 14.05 14.93 15.02 15.31C15.79 15.61 15.83 15.77 15.93 16H8.07ZM12 8C12.55 8 13 8.45 13 9C13 9.55 12.55 10 12 10C11.45 10 11 9.55 11 9C11 8.45 11.45 8 12 8ZM12 6C10.34 6 9 7.34 9 9C9 10.66 10.34 12 12 12C13.66 12 15 10.66 15 9C15 7.34 13.66 6 12 6Z" fill="#49454F"/>
              </g>
              <defs>
                <clipPath id="clip0_2954_454">
                  <rect width="24" height="24" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </span>
          @if (isExpanded()) {
            <span class="nav-item-label">{{ 'nav.cuentas' | translate }}</span>
          }
        </a>

        <!-- Reportes -->
        <a
          class="nav-item"
          routerLink="/detalle-consumo"
          routerLinkActive="active"
          [attr.title]="isExpanded() ? '' : ('nav.reportes' | translate)"
          attr.aria-label="{{ 'nav.reportes' | translate }}"
          (click)="closeNavOnMobile()"
        >
          <span class="nav-item-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
              <path d="M14 8V0H6V6H0V18H20V8H14ZM8 2H12V16H8V2ZM2 8H6V16H2V8ZM18 16H14V10H18V16Z" fill="#49454F"/>
            </svg>
          </span>
          @if (isExpanded()) {
            <span class="nav-item-label">{{ 'nav.reportes' | translate }}</span>
          }
        </a>

      </nav>

      @if (!isExpanded()) {
        <div class="nav-utilities nav-utilities--collapsed" aria-label="Acciones de usuario">
          <div class="language-selector-wrapper">
            <button class="utility-item" type="button" attr.title="{{ 'nav.idioma' | translate }}" attr.aria-label="{{ 'nav.idioma' | translate }}"
              [attr.aria-expanded]="isLanguageSelectorVisible()"
              (click)="toggleLanguageSelector($event)">
              <span class="utility-icon" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM16.92 6H13.97C13.65 4.75 13.19 3.55 12.59 2.44C14.43 3.07 15.96 4.35 16.92 6ZM10 2.04C10.83 3.24 11.48 4.57 11.91 6H8.09C8.52 4.57 9.17 3.24 10 2.04ZM2.26 12C2.1 11.36 2 10.69 2 10C2 9.31 2.1 8.64 2.26 8H5.64C5.56 8.66 5.5 9.32 5.5 10C5.5 10.68 5.56 11.34 5.64 12H2.26ZM3.08 14H6.03C6.35 15.25 6.81 16.45 7.41 17.56C5.57 16.93 4.04 15.66 3.08 14ZM6.03 6H3.08C4.04 4.34 5.57 3.07 7.41 2.44C6.81 3.55 6.35 4.75 6.03 6ZM10 17.96C9.17 16.76 8.52 15.43 8.09 14H11.91C11.48 15.43 10.83 16.76 10 17.96ZM12.34 12H7.66C7.57 11.34 7.5 10.68 7.5 10C7.5 9.32 7.57 8.65 7.66 8H12.34C12.43 8.65 12.5 9.32 12.5 10C12.5 10.68 12.43 11.34 12.34 12ZM12.59 17.56C13.19 16.45 13.65 15.25 13.97 14H16.92C15.96 15.65 14.43 16.93 12.59 17.56ZM14.36 12C14.44 11.34 14.5 10.68 14.5 10C14.5 9.32 14.44 8.66 14.36 8H17.74C17.9 8.64 18 9.31 18 10C18 10.69 17.9 11.36 17.74 12H14.36Z" fill="#49454F"/>
                </svg>
              </span>
            </button>
            <app-language-selector [isVisible]="isLanguageSelectorVisible()"
              (close)="isLanguageSelectorVisible.set(false)"
              (languageChanged)="onLanguageChanged($event)">
            </app-language-selector>
          </div>

          <div class="account-wrapper">
            <button class="utility-item" type="button" attr.title="{{ 'nav.miCuenta' | translate }}" attr.aria-label="{{ 'nav.miCuenta' | translate }}"
              [attr.aria-expanded]="isAccountDropdownVisible()"
              (click)="toggleAccountDropdown($event)">
              <span class="utility-icon" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="29" height="26" viewBox="0 0 29 26" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M20.092 6C20.092 9.31371 17.4058 12 14.092 12C10.7783 12 8.09204 9.31371 8.09204 6C8.09204 2.68629 10.7783 0 14.092 0C17.4058 0 20.092 2.68629 20.092 6ZM18.092 6C18.092 8.20914 16.3012 10 14.092 10C11.8829 10 10.092 8.20914 10.092 6C10.092 3.79086 11.8829 2 14.092 2C16.3012 2 18.092 3.79086 18.092 6Z" fill="#D85D7F"/>
                  <path d="M14.092 15C7.61766 15 2.10132 18.8284 0 24.192C0.511895 24.7004 1.05114 25.1812 1.61533 25.6321C3.18007 20.7077 8.08876 17 14.092 17C20.0953 17 25.004 20.7077 26.5688 25.6321C27.133 25.1812 27.6722 24.7004 28.1841 24.1921C26.0828 18.8284 20.5664 15 14.092 15Z" fill="#D85D7F"/>
                </svg>
              </span>
            </button>
            <div class="account-dropdown" [class.open]="isAccountDropdownVisible()">
              <button class="dropdown-item" (click)="logout()">
                <span class="dropdown-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M17 8L15.59 9.41L17.17 11H9V13H17.17L15.59 14.58L17 16L21 12L17 8ZM5 5H12V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H12V19H5V5Z" fill="#49454F"/>
                  </svg>
                </span>
                <span class="dropdown-text">{{ 'nav.cerrarSesion' | translate }}</span>
              </button>
            </div>
          </div>
        </div>
      }

    </div><!-- /nav-drawer-body -->

    @if (isExpanded()) {
      <div class="nav-divider nav-divider--bottom"></div>
      <a class="utility-item utility-item--logout" routerLink="/login" (click)="logout()" attr.aria-label="{{ 'nav.cerrarSesion' | translate }}">
        <span class="utility-icon" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M17 8L15.59 9.41L17.17 11H9V13H17.17L15.59 14.58L17 16L21 12L17 8ZM5 5H12V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H12V19H5V5Z" fill="#49454F"/>
          </svg>
        </span>
        <span class="utility-label">{{ 'nav.cerrarSesion' | translate }}</span>
      </a>
      <div class="nav-utilities nav-utilities--expanded" aria-label="Acciones de usuario">
        <img
          class="nav-signature"
          src="assets/images/firm-platform-by-myservy.png"
          alt="Firma de la empresa MyServy"
        />
      </div>
    }

  </aside>

  <!-- ===== MAIN CONTENT ===== -->
  <main class="main-content" [class.expanded]="isExpanded()">
    <div class="content-wrapper">
      <div class="content-container">
        <router-outlet></router-outlet>
      </div>

      <div class="signature-container" aria-label="Powered by Dow Jones">
        <img
          src="assets/images/Powered-Dow-Jones-1.png"
          alt="Powered by Dow Jones"
          class="signature-image"
        />
      </div>
    </div>
  </main>

</div>
